import { Table } from "melco-ui";
import { useTranslation } from "react-i18next";
// import { CancelDrawer } from "./drawer/Cancel/CancelDrawer";
import { MelcoModelsUserDeviceListItem } from "melco-shared-logic";
import { useUserDevices } from "../../../hooks/users/useUserDevices";
import { DeviceLogoutActionButton } from "../DeviceLogoutActionButton";

type UserDevicesPropTypes = {
  userId: string;
  productCode: string;
};

export const UserDevicesList: React.FC<UserDevicesPropTypes> = ({
  userId,
  productCode,
}) => {
  const {
    isLoading,
    isFetching,
    data,
    isPreviousData,
    errorComponent,
    onTableConfigChange,

    refetch,
  } = useUserDevices(userId, productCode);

  const { t } = useTranslation();

  const callBackFn = () => {
    refetch();
  };

  const columns = [
    {
      title: t("users.tabs.devices.table.columns.name"),
      key: "name",
      dataIndex: "name",
      // sorter: true,
      width: 30,
    },
    {
      title: t("users.tabs.devices.table.columns.logged_on"),
      key: "logged_on",
      //dataIndex: "product_code",
      // sorter: true,
      width: 30,
      render: (rowObj: MelcoModelsUserDeviceListItem) => {
        return (
          <>
            {rowObj.logged_on
              ? new Date(rowObj.logged_on).toLocaleString()
              : ""}
          </>
        );
      },
    },
    {
      title: t("users.tabs.devices.table.columns.seconds_to_expire"),
      key: "seconds_to_expire",
      //dataIndex: "subscription_code",
      //  sorter: true,
      width: 30,
      render: (rowObj: MelcoModelsUserDeviceListItem) => {
        let logged_on = rowObj.logged_on ? rowObj.logged_on.toDateString() : "";
        console.log(logged_on);

        let logged_on_miliseconds = new Date(logged_on)
          ? new Date(logged_on).getTime()
          : 0;
        console.log(logged_on_miliseconds);

        let miliseconds_to_expire = rowObj.seconds_to_expire
          ? rowObj.seconds_to_expire * 1000
          : 0;

        let totalMiliseconds = logged_on_miliseconds + miliseconds_to_expire;

        return (
          <>
            {totalMiliseconds
              ? new Date(totalMiliseconds).toLocaleString()
              : ""}
          </>
        );
      },
    },
    {
      title: t("users.tabs.devices.table.columns.logged_off"),
      key: "logged_off",
      // dataIndex: "referral_code",
      //sorter: true,
      width: 30,
      render: (rowObj: MelcoModelsUserDeviceListItem) => {
        return (
          <>
            {rowObj.logged_off
              ? t("users.tabs.devices.table.deactive")
              : t("users.tabs.devices.table.active")}
          </>
        );
      },
    },
    {
      title: t("users.tabs.devices.table.columns.operating_system_name"),
      key: "operating_system_name",
      dataIndex: "operating_system_name",
      // sorter: true,
      width: 30,
    },
    {
      title: t("users.tabs.devices.table.columns.operating_system_version"),
      key: "operating_system_version",
      dataIndex: "operating_system_version",
      // sorter: true,
      width: 30,
    },
    {
      title: t("users.tabs.devices.table.columns.actions"),
      key: "actions",
      //dataIndex: "",
      // sorter: true,
      width: 30,
      render: (rowObj: MelcoModelsUserDeviceListItem) => (
        <>
          <DeviceLogoutActionButton
            userId={userId}
            productCode={productCode}
            deviceIdToLogout={rowObj.device_id ?? ""}
            callBackFn={callBackFn}
          />
        </>
      ),
    },
  ];

  return (
    <>
      <div>
        <Table
          // showSorterTooltip={false}
          sticky
          loading={isPreviousData ? isFetching : isLoading}
          dataSource={data}
          columns={columns}
          onChange={onTableConfigChange}
          // pagination={pagination}
          pagination={false}
          rowKey="device_id"
          // rowSelection={rowSelection}
          // onRow={onRow}
          noDataMessage={t("users.tabs.devices.table.no_data_message")}
          errorComponent={errorComponent}
          //scroll={{ x: 1700 }}
        />
      </div>
    </>
  );
};
